/**
 * Module for common utilities for working with component props.
 */

/**
 * Finds data attributes given a props object.
 * The result is generally intended for props spreading.
 *
 * Note that `data-` and `aria-` props don't need to be declared in a
 * component's props type.
 *
 * @param props Any props.
 */
export const findDataAttrProps = (props: {
  // tslint:disable-next-line: no-any
  [key: string]: any;
}): { [key: string]: string } => {
  const dataAttrs: { [key: string]: string } = {};
  Object.keys(props)
    .filter((key) => key.startsWith('data-'))
    .forEach((dataKey) => (dataAttrs[dataKey] = props[dataKey]));
  return dataAttrs;
};
